/** @format */
import React, { useEffect, useState } from 'react';
import { DialogContent, Grid } from '@material-ui/core';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { isMobileOnly, isTablet } from 'react-device-detect';
import clsx from 'clsx';
import { useSelector } from 'src/store';

const GridLayoutInDialog = WidthProvider(Responsive);

const calcSize = (size, item) => {
  switch (size) {
    case 'small':
      return { w: item.w || 3, h: item.h || 2, minW: 3, maxW: 6, minH: 2, maxH: 6 };
    case 'normal':
      return { w: item.w || 3, h: item.h || 4, minW: 3, maxW: 6, minH: 2, maxH: 6 };
    case 'wide':
      return { w: item.w || 4, h: item.h || 4, minW: 3, maxW: 6, minH: 2, maxH: 6 };
    case 'medium':
      return { w: item.w || 4, h: item.h || 4, minW: 3, maxW: 6, minH: 2, maxH: 6 };
    case 'large':
      return { w: item.w || 6, h: item.h || 4, minW: 3, maxW: 8, minH: 2, maxH: 6 };
    case 'xwide':
      return { w: item.w || 8, h: item.h || 4, minW: 3, maxW: 10, minH: 2, maxH: 6 };
    case 'fullWidth':
      return { w: item.w || 12, h: item.h || 4, minW: 3, maxW: 12, minH: 2, maxH: 6 };
    default:
      return { w: item.w || 4, h: item.h || 4, minW: 3, maxW: 5, minH: 2, maxH: 6 };
  }
};
const generateLayout = (item, index, totalWidthOfItems, changeTotalWidthOfItems, itemPositions) => {
  const { size, x, y } = item;

  changeTotalWidthOfItems(calcSize(size, item).w);
  const layoutRenerated = {
    i: item.type + item.title,
    x: item.x != null ? item.x : itemPositions[index] !== null ? itemPositions[index].x : totalWidthOfItems % 12,
    y:
      item.y != null
        ? item.y
        : itemPositions[index] !== null
          ? itemPositions[index].y
          : Math.floor(totalWidthOfItems / 12),
    ...calcSize(size, item)
  };

  return layoutRenerated;
};
let totalWidthOfItems = 0;
const changeTotalWidthOfItems = data => {
  totalWidthOfItems += data;
};

const DummyWidget = ({ widgetInfo, defaultProps, lang, setOpenDialog }) => {
  const [toggleFlag, setToggleFlag] = useState(false);
  const [globalLayouts, setLayouts] = useState({});
  const [currentDrag, setCurrentDrag] = useState(null);
  const [itemPositions, setItemPositions] = useState([]);
  const { tickets } = useSelector(state => state.tickets);
  const [widgets, setWidgets] = useState(() => {
    return [
      {
        type: 'support',
        title: 'Support Services',
        size: 'xwide',
        tickets: tickets
          ? [...tickets].sort((a, b) => new Date(b.createdon) - new Date(a.createdon)).slice(0, 4)
          : null,
        isNew: 0,
        w: 8,
        minW: null,
        maxW: null,
        h: 4,
        minH: null,
        maxH: null
      },
      ...widgetInfo.data
        .filter(item => {
          if (lang === 'en' || lang === 'de' || lang === 'en-GB') {
            return item.tag !== 'tis-web-orders' && item.tag !== 'tis-web-invoices';
          }
          return true;
        })
        .map((item, index) => ({
          i: item.type + item.title,
          title: item.title,
          size: item.size,
          type: item.type,
          isNew: 0,
          w: null,
          minW: null,
          maxW: null,
          h: null,
          minH: null,
          maxH: null
        }))
    ];
  });
  const [additionalWidget, setAdditionalWidget] = useState([
    {
      i: '1001',
      size: 'wide',
      type: 'Test',
      isNew: 1,
      title: 'Additional Widget 1',
      w: 4,
      minW: 3,
      maxW: 6,
      h: 2,
      minH: 1,
      maxH: 3
    },
    {
      i: '1002',
      size: 'normal',
      type: 'Test',
      isNew: 1,
      title: 'Additional Widget 2',
      w: 3,
      minW: 3,
      maxW: 6,
      h: 2,
      minH: 1,
      maxH: 3
    }
  ]);

  useEffect(() => {
    const calculateItemPositions = () => {
      const positions = [];
      let currentX = 0;
      let currentY = 0;
      let maxHeightInRow = 0;

      if (widgets.length) {
        widgets.forEach((item, index) => {
          const itemWidth = calcSize(item.size, item).w;
          const itemHeight = calcSize(item.size, item).h;

          if (
            item.type === 'contact' &&
            widgets[index - 1] &&
            widgets[index - 1].type &&
            widgets[index - 1].type === 'contact'
          ) {
            const itemPrevWidth = calcSize(widgets[index - 1].size, widgets[index - 1]).w;
            const itemPrevHeight = calcSize(widgets[index - 1].size, widgets[index - 1]).h;
            currentX -= itemPrevWidth;
            currentY += itemHeight;
          } else if (currentX + itemWidth > 12) {
            currentX = 0;
            currentY += maxHeightInRow;
            maxHeightInRow = 0;
          }

          positions.push({
            x: currentX,
            y: currentY
          });

          currentX += itemWidth;
          if (itemHeight > maxHeightInRow) {
            maxHeightInRow = itemHeight;
          }
        });
      }
      return positions;
    };

    if (widgets.length && itemPositions.length === 0) setItemPositions(calculateItemPositions());
    if (widgets.length && itemPositions.length) {
      const layoutArr = [];
      const newWigets = [];
      widgets.forEach((item, index) => {
        const dataGrid = generateLayout(item, index, totalWidthOfItems, changeTotalWidthOfItems, itemPositions);
        layoutArr.push(dataGrid);
        newWigets.push({
          ...item,
          x: dataGrid.x,
          y: dataGrid.y,
          w: dataGrid.w,
          minW: dataGrid.minW,
          maxW: dataGrid.maxW,
          h: dataGrid.h,
          minH: dataGrid.minH,
          maxH: dataGrid.maxH
        });
      });
      setWidgets(newWigets);
      setLayouts({ ...globalLayouts, xl: layoutArr, lg: layoutArr, xxl: layoutArr });
    }
  }, [toggleFlag, itemPositions]);

  const onDropDragOver = e => ({ w: currentDrag.w, h: currentDrag.h });
  // START onDrop
  const onDrop = (layouts, layoutItem, _event) => {
    const newWidgets = widgets.map(widget => {
      const newWidgetPosition = layouts.find(l => l.i === widget.i);
      if (newWidgetPosition) {
        return { ...widget, x: newWidgetPosition.x, y: newWidgetPosition.y };
      }
      return widget;
    });
    setWidgets([...newWidgets, { ...currentDrag, ...layoutItem }]);
    setAdditionalWidget(additionalWidget.filter(a => a.i !== currentDrag.i));
    setToggleFlag(!toggleFlag);
  };
  // STOP onDrop
  const onLayoutChange = (key, layouts) => {
    if (Object.keys(globalLayouts).length === 0) setLayouts(layouts);
  };
  const onDragStart = (layouts, oldItem, newItem) => {};
  const onDrag = (layouts, oldItem, newItem) => {};
  const onDragStop = (layouts, oldItem, newItem) => {};
  const handleDeleteItem = deletedItem => {
    setAdditionalWidget([...additionalWidget, deletedItem]);
    const layoutArr = [];
    const newWigets = [];
    widgets
      .filter(a => a.i !== deletedItem.i)
      .forEach((item, index) => {
        const dataGrid = generateLayout(item, index, totalWidthOfItems, changeTotalWidthOfItems, itemPositions);
        const itemResize = deletedItem.i === item.i ? deletedItem : item;
        layoutArr.push({ ...dataGrid, w: itemResize.w, h: itemResize.h });
        newWigets.push({
          ...item,
          x: dataGrid.x,
          y: dataGrid.y,
          w: itemResize.w,
          minW: dataGrid.minW,
          maxW: dataGrid.maxW,
          h: itemResize.h,
          minH: dataGrid.minH,
          maxH: dataGrid.maxH
        });
      });
    setWidgets(newWigets);
    setLayouts({ ...layoutArr, xl: layoutArr, lg: layoutArr, xxl: layoutArr });
  };
  const onResizeStop = (layout, oldItem, newItem) => {
    const layoutArr = [];
    const newWigets = [];
    widgets.forEach((item, index) => {
      const dataGrid = generateLayout(item, index, totalWidthOfItems, changeTotalWidthOfItems, itemPositions);
      const itemResize = newItem.i === item.i ? newItem : item;
      layoutArr.push({ ...dataGrid, w: itemResize.w, h: itemResize.h });
      newWigets.push({
        ...item,
        x: dataGrid.x,
        y: dataGrid.y,
        w: itemResize.w,
        minW: dataGrid.minW,
        maxW: dataGrid.maxW,
        h: itemResize.h,
        minH: dataGrid.minH,
        maxH: dataGrid.maxH
      });
    });
    setWidgets(newWigets);
    setLayouts({ ...globalLayouts, xl: layoutArr, lg: layoutArr, xxl: layoutArr });
  };

  return (
    <DialogContent style={{ padding: 30 }}>
      <Grid container style={{ overflow: 'hidden' }} justifyContent="flex-end">
        <button onClick={() => setOpenDialog(false)} className="dashboard-config-button-close">
          Close
        </button>
      </Grid>
      <Grid container className="grid-modify" style={{ overflow: 'hidden' }}>
        <Grid item xs={9}>
          {widgets.length > 0 ? (
            <GridLayoutInDialog
              style={{ margin: 0 }}
              currentBreakpoint={'lg'}
              cols={{ xxl: 12, lg: 12, xl: 12, md: 6, sm: 6, xs: 1, xxs: 1 }}
              breakpoints={{ xxl: 1800, lg: 1300, xl: 992, md: 768, sm: 575, xs: 375, xxs: 0 }}
              className="widgetlayout active-drag"
              margin={[4, 4]}
              rowHeight={40}
              layouts={globalLayouts}
              isDraggable={true}
              isResizable={true}
              isDroppable={true}
              droppingItem={currentDrag}
              onDrop={onDrop}
              onDropDragOver={onDropDragOver}
              onLayoutChange={onLayoutChange}
              onDragStart={onDragStart}
              onDrag={onDrag}
              onDragStop={onDragStop}
              onResizeStop={onResizeStop}
            >
              {widgets.map((item, index, items) => {
                return (
                  <div key={item.type + item.title}>
                    <span className={`overlay-drag ${item.isNew ? 'new' : ''}`}>
                      <strong>{item.type}</strong>
                      <span>{item.title}</span>
                    </span>
                    <button onClick={() => handleDeleteItem(item)} className={`remove delete-item`}>
                      x
                    </button>
                  </div>
                );
              })}
            </GridLayoutInDialog>
          ) : null}
        </Grid>
        <Grid item xs={3}>
          <div className="widgetsShop">
            <h1>Widget Library</h1>
            <h3>Ausgeblendete Widgets / Widget Shop</h3>

            <div className="additional-widget">
              {additionalWidget.map(a => {
                return (
                  <div
                    key={a.i}
                    data-grid={{ i: a.i, w: a.w, h: a.h }}
                    className={clsx('droppable-element', a.isNew && 'is-new')}
                    draggable={true}
                    unselectable="on"
                    onDragStart={e => {
                      e.dataTransfer.setData('text/plain', a.title);
                      setCurrentDrag(a);
                    }}
                  >
                    <strong>{a.type}</strong>
                    <span>{a.title}</span>
                  </div>
                );
              })}
            </div>
          </div>
        </Grid>
      </Grid>
    </DialogContent>
  );
};

export default DummyWidget;
